import React, { Fragment, useCallback, useEffect, useRef, useState, useContext } from "react";
import {
  Col,
  Row,
  Select,
  Input,
  Form,
  Icon,
  message,
  Button,
  Tooltip,
} from "antd";
import polygonActive from "../../../assets/images/triangle.svg";
import SectionCard from "./SectionCard";
import ReusableInput from "./ReusableInput";
import "./ItemsMeasure.scss";
import ButtonComponent from "./Button_v2";
import TableComponent from "./Table_v2";
import AppConfig from "../../config/AppConfig";
import { fetchAccountDims } from "../../api/Account";
import { formatDimension_v2, formatWeight } from "../../helpers/orders";
import _, { isNaN } from "lodash";
import {
  fetchItemExceptions,
  updateOrderDetails_v2,
} from "../../api/OrdersApi";
import InfoIcon, {
  ArrowDownIcon,
  CircledCloseIcon,
  DeleteMinusIcon,
} from "../../common/CustomIcon";
import { convertToKilograms, convertToPounds, renderAlertMessage, roundToDecimals } from "../../helpers/common";
import ItemGrouping from "../../components/orders/ItemGrouping";
import ModalComponent from "./Modal_v2";
import Button_v2 from "./Button_v2";
import CloseIcon from "../../../assets/images/IconClose.svg";
import Table_v2 from "./Table_v2";
import { isEmpty } from "../../common/Common";
import InfoTooltip from "../../stories/components/InfoTooltip";
import moment from "moment";
import ImageViewer from "../../components/common/ImageViewer";
import { UserContext } from "../../context/UserContext";
import { getValueFromArrayOfObjects } from "../../helpers/array_functions";
import ApprovalRequiredModal from "../../components/configurations/orderApproval/ApprovalRequiredModal";
import { validateApprovalError } from "../../helpers/approvalHelper";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
// import { InputMeasureGridList, ItemsMeasureGridList } from "./ItemsMeasureGridList";
// import { ScreenKeys } from "../../containers/constants";

const { Option } = Select;

const ItemsMeasure = (props) => {
  const { orgRules } = useContext(UserContext);

  const isDimsMandatory = orgRules?.org_billing_rules?.required_dims == "true" || false;
  const roundOffDecimalsForDistance = 2;
  // State to store input values
  const {
    getDataRef,
    currentOrg,
    typeOfOrder,
    accountId,
    actionType = "create",
    currentOrder = {},
    refreshDetails,
    form,
    locationsData,
    isShipper = false,
    showActions = true,
    orgSettings = {},
    updateItemDetails = () => {},
    screenFrom = "orders"
  } = props;
  const { getFieldValue, setFieldsValue, getFieldDecorator } = form;
  const { customer_order_details: details = {} } = currentOrder;
  const requireItems = orgSettings?.require_items_on_order_creation == "true" || false;

  const defaultMeasureValue = (value, fallback) =>
    requireItems ? (value || 0) : (value || fallback);

  const toTwoDecimals = (value) =>
    _.isFinite(Number(value)) ? Number(value).toFixed(2) : "";

  const [formData, setFormData] = useState({
    weight: defaultMeasureValue(details?.weight, 1),
    actual_weight: defaultMeasureValue(details?.actual_weight, 1),
    actual_weight_in_kgs: defaultMeasureValue(details?.actual_weight_in_kgs, 0.453592),
    quantity: defaultMeasureValue(details?.quantity, 1),
    surface_area: defaultMeasureValue(details?.surface_area, 1),
    pallets: defaultMeasureValue(details?.pallets, 1),
    weight_uom: details?.weight_uom || "lbs",
    dimensions_units: "in",
    weight_in_kgs: defaultMeasureValue(details?.weight_in_kgs, 0.453592),
    mileage : !_.isNil(details?.mileage) ? _.isFinite(Number(details?.mileage)) ? roundToDecimals(details?.mileage, roundOffDecimalsForDistance) : "NA" : "",
    cbm_volume:  details?.cbm_volume || '',
    declared_value: details?.declared_value || '',
  });

  // State to handle table visibility and data
  const [dataSource, setDataSource] = useState([]);
  const [dimObject, setDimObject] = useState({});
  const [showTable, setShowTable] = useState(["view","update"].includes(actionType));
  const [isReadOnly, setIsReadOnly] = useState(actionType === "view");
  const [isEditting, setIsEditting] = useState(false);
  const [groupitemEnable, setGroupItemEnable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemException, setItemException] = useState([]);
  const [hoveredField, setHoveredField] = useState(null);
  const [currentGridRef, setCurrentGridRef] = useState(null);
  const [approvalModal, setApprovalModal] = useState(false);
  const [isHazmat,setIsHazmat] = useState(false);
  const [isDeclared, setIsDeclared] = useState(false);
  const [approvalRules, setApprovalRules] = useState([]);
  const [restrictionMessage, setRestrictionMessage] = useState([]);

  const emptyText = "Not Available";

    const gridRef = useRef(null);
  
    const onGridReady = (params) => {
      setCurrentGridRef(params.api);
      gridRef.current = params.api;
    };
  

const timeFormat = props.isMilitaryTime === true ? "MMM DD, YYYY HH:mm" : "MMM DD, YYYY hh:mm A";

  useEffect(() => {
    if (getDataRef) {
      getDataRef.current = () => ({
        items: [...dataSource],
        measurements: {
          ...formData,
          // weight: convertToLbs(formData.weight, formData.item_weight_uom),
        },
      });
    }
  }, [dataSource, formData, getDataRef]);

  useEffect(() => {
    if (actionType === "update") {
      setIsReadOnly(false);
      setIsEditting(true);
    }
  },[actionType])

  // Handler to update state on input change with validation for non-negative values
  const handleInputChange = (field, value) => {
    const validatedValue = Math.max(0, value);
    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: validatedValue };

      if (field === "weight") {
        const weightInKgs = (validatedValue * 0.453592).toFixed(2);
        updatedData = {
          ...updatedData,
          weight_in_kgs: parseFloat(weightInKgs),
        };
        form.setFieldsValue({ weight_in_kgs: parseFloat(weightInKgs) });
      } else if (field === "weight_in_kgs") {
        const weightInLbs = (validatedValue / 0.453592).toFixed(2);
        updatedData = { ...updatedData, weight: parseFloat(weightInLbs) };
        form.setFieldsValue({ weight: parseFloat(weightInLbs) });
      } else if (field === "actual_weight") {
        const actualWeightInKgs = (validatedValue * 0.453592).toFixed(2);
        updatedData = { ...updatedData, actual_weight_in_kgs: parseFloat(actualWeightInKgs) };
        form.setFieldsValue({ actual_weight_in_kgs: parseFloat(actualWeightInKgs) });
      } else if (field === "actual_weight_in_kgs") {
        const actualWeightInLbs = (validatedValue / 0.453592).toFixed(2);
        updatedData = { ...updatedData, actual_weight: parseFloat(actualWeightInLbs) };
        form.setFieldsValue({ actual_weight: parseFloat(actualWeightInLbs) });
      }else if(field === "declared_value"){  
        updatedData = { ...updatedData, declared_value: validatedValue };
        form.setFieldsValue({ declared_value: validatedValue });
      } else if (field === "cbm_volume") {
        const cbmVolume = parseFloat(validatedValue);
        const cbmFactor = parseFloat(orgSettings?.cbm_volume);
        
        if (!isNaN(cbmVolume) && !isNaN(cbmFactor)) {
          const calculatedWeight = Math.floor(cbmVolume * cbmFactor);
          const weightInKgs = calculatedWeight * 0.453592 ; //convertToKilograms(calculatedWeight, false, 4);
          const currentWeight = updatedData["weight"];
          // if (isEmpty(currentWeight) || Number(currentWeight) <= calculatedWeight) {
            updatedData.weight = calculatedWeight;
            updatedData.weight_in_kgs = weightInKgs;
            form.setFieldsValue({ weight: calculatedWeight, weight_in_kgs: weightInKgs });

          //}
        }
        
        updatedData = { ...updatedData, cbm_volume: cbmVolume };
      }
      

      return updatedData;
    });
  };

  // Handler for 'Add Item' button click
  const handleAddItemClick = () => {
    setShowTable(true);
    setIsReadOnly(false);
    handleAddNewRow();
  };

  // Handler for 'Add Item' button click
  const handleEditItemClick = () => {
    setIsReadOnly(false);
    setIsEditting(true);
  };

  const handleGroupItemClick = () => {
    setGroupItemEnable(true);
  };

     const handleApprovalValidation = (result) => {
    const {
      isHazmat,
      isDeclared,
      messages,
      requiresApproval,
    } = validateApprovalError(result.approval_errors);
  
    if (isHazmat) setIsHazmat(true);
    if (isDeclared) setIsDeclared(true);
  
    if (requiresApproval) {
      setApprovalModal(true);
      setRestrictionMessage(messages);
    }
  };

  const handleCloseApprovalModal = () => {
    setApprovalModal(false);
    setIsHazmat(false);
    setIsDeclared(false);
  }

  const handleSaveItemClick = async () => {


    if (requireItems) {

      if (dataSource.length === 0) {
        renderNotification("Please add at least one item", "error");
        return;
      }

      for (const [index, item] of dataSource.entries()) {
        if (isEmpty(item.item_weight, true)) {
          renderNotification(`Item ${index + 1} weight is required`, "error");
          return;
        }
      }
    }

    if (isDimsMandatory) {
      for (const [index, item] of dataSource.entries()) {
        if (isEmpty(item.item_length, true) || isEmpty(item.item_width, true) || isEmpty(item.item_height, true)) {
          renderNotification(`Item ${index + 1} dimensions are required`, "error");
          return;
        }
      }
    }
    // Prepare the formatted data as payload
    // const formattedData = { ...formData, items: [...dataSource] };
    const formattedData = {
      ...formData,
      mileage: formData.mileage || 0,
      items: dataSource.map((item) => {
        const dimUnits = item.dimensions_units || item.item_length_uom || "in";

        return {
          ...item,
          item_weight: isEmpty(item.item_weight) || isEmpty(item.item_weight_in_kgs) ? 0 : _.toNumber(item.item_weight),
          item_weight_in_kgs: isEmpty(item.item_weight) || isEmpty(item.item_weight_in_kgs) ? 0 : _.toNumber(item.item_weight_in_kgs),
          item_weight_uom: item.item_weight_uom ?? "lbs",
          item_height: item.item_height,
          item_length: item.item_length,
          item_width: item.item_width,
          dimensions_units: dimUnits,
          item_length_uom: dimUnits,
          item_height_uom: dimUnits,
          item_width_uom: dimUnits,
        };
      }),
    };
      
    const payload = {
      customer_order_params: {
        customer_order_id: details.id,
        warehouse_id: currentOrder.customer_order_details.warehouse_id,
        organization_id: currentOrg?.id || "",
        location_id: "",
        is_hazmat_request_approval: isHazmat.toString(),
        is_declared_request_approval: isDeclared.toString(),
      },
      items_params: formattedData,
    };
  
    try {
      const response = await updateOrderDetails_v2(currentOrder.id, payload);
      if(response.success){
        const itemDetails = {
          ...response?.response?.items_details,
          items: response?.response?.items_details?.items?.map(item => ({
              ...item,
              pickup_loc_seq: getValueFromArrayOfObjects(currentOrder.locations, "location_id", item.pick_up_location_id, "loc_order_sequence" ),
              delivery_loc_seq: getValueFromArrayOfObjects(currentOrder.locations, "location_id", item.drop_location_id, "loc_order_sequence" ),
            }))
          }
        updateItemDetails(itemDetails);
       setFormData((prev) => ({
          ...prev,
          declared_value: itemDetails.declared_value,
        }));
        setIsEditting(false);
        setIsReadOnly(true); 
      setApprovalModal(false)   // refreshDetails();
        refreshDetails();
      }else if(response?.errors?.length > 0) {
        renderAlertMessage(response.errors);   
      }
       if(response.approval_errors && !isEmpty(response.approval_errors)){
                handleApprovalValidation(response);
              }
    } catch (error) {
      console.error("Error updating order details", error);
    } finally {   
    }
  };


  // Function to format numbers to 2 decimal places
  const formatToTwoDecimals = (value) => {
    const parsedValue = parseFloat(value);
    if (Number.isInteger(parsedValue)) {
      return parsedValue.toString();
    }
    return parsedValue.toFixed(2);
  };

  // Handler to update table data
  const handleTableChange = (value, field, key) => {
    const dimWeightDependency = [
      "item_length",
      "item_width",
      "item_height",
      "item_weight",
      "item_weight_in_kgs",
      "item_quantity",
      "item_pallets",
      "dimensions_units", // Added dimensions_units to dependency
      "dim_factor"
    ];
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        const updatedItem = { ...item, [field]: value };
  
        // Handle weight conversion
        if (field === "item_weight") {
          updatedItem.item_weight_in_kgs = parseFloat(
            (value * 0.453592).toFixed(2)
          );
        } else if (field === "item_weight_in_kgs") {
          updatedItem.item_weight = parseFloat((value / 0.453592).toFixed(2));
        }
  
        // Handle dimensions_units conversion to inches
        // if (field === "dimensions_units" && value === "ft") {
        //   updatedItem.item_height = parseFloat(
        //     (updatedItem.item_height * 12).toFixed(2)
        //   );
        //   updatedItem.item_length = parseFloat(
        //     (updatedItem.item_length * 12).toFixed(2)
        //   );
        //   updatedItem.item_width = parseFloat(
        //     (updatedItem.item_width * 12).toFixed(2)
        //   );
        //   updatedItem.dimensions_units = "in";
        // }
  
        // Calculate dimensional weight if field affects it
        if (dimWeightDependency.includes(field)) {
          const dimWeight = calculateDimValue(updatedItem);
          updatedItem.dim_weight = dimWeight;
        }
  
        return updatedItem;
      }
      return item;
    });
  
    setDataSource(newData);
    updateItemTotalWeight(newData, key);
    updateOrderTotalWeight(newData);
  };

  // Function to calculate dim weight
  const calculateDimValue = (record) => {
    let totalItemWeight = 0;
    let itemQuantity = !isEmpty(record.item_quantity) ? record.item_quantity : 1;
    const dimUnits = record.dimensions_units || record.item_length_uom || 'in';
    const inFactor = dimUnits === 'cm' ? 0.3937 : dimUnits === 'ft' ? 12 : 1;
    const lengthIn = Math.round((!isEmpty(record.item_length) ? record.item_length : 1) * inFactor * 100) / 100;
    const widthIn = Math.round((!isEmpty(record.item_width) ? record.item_width : 1) * inFactor * 100) / 100;
    const heightIn = Math.round((!isEmpty(record.item_height) ? record.item_height : 1) * inFactor * 100) / 100;
    const weight = !isEmpty(record.item_weight) ? record.item_weight : 0;
    const dimFactor = record.dim_factor || dimObject?.dim_factor;
    if ((widthIn || heightIn || lengthIn) && !isEmpty(dimFactor)) {
      const configuredMinWeight = !isEmpty(dimObject.min_weight)
        ? dimObject.min_weight
        : 0;
      if (
        (configuredMinWeight === 0 || configuredMinWeight < weight) &&
        dimFactor > 0
      ) {
        const multiplyQuantity = orgSettings?.dim_wt_calc_based_on_skid_and_pallets === "skids_pallets"
          ? (!isEmpty(record.item_pallets) ? record.item_pallets : 1)
          : itemQuantity;
        totalItemWeight = Math.round((widthIn * heightIn * lengthIn) / dimFactor * multiplyQuantity);
      }
      return totalItemWeight;
    }
  };

  // Function to update orders total weight in formData

  const updateOrderTotalWeight = (data) => {
    if (!requireItems) return; // don't override manual entry when items aren't mandatory

    const totalWeight = data.reduce((sum, item) => {
      const itemQuantity = isEmpty(item.item_quantity) ? 1 : Number(item.item_quantity);
      const itemWeight = isEmpty(item.item_weight) ? 0 : Number(item.item_weight);
      const itemTotalWeight =
        item.weight_type === "individual"
          ? itemQuantity * itemWeight
          : itemWeight;
      return sum + (isNaN(itemTotalWeight) ? 0 : itemTotalWeight);
    }, 0);

    const roundedWeight = parseFloat(totalWeight.toFixed(2));
    const weightInKgs = parseFloat((roundedWeight * 0.453592).toFixed(2));

    setFormData((prevData) => ({
      ...prevData,
      weight: roundedWeight,
      weight_in_kgs: weightInKgs,
    }));
    form.setFieldsValue({ weight: roundedWeight, weight_in_kgs: weightInKgs });
  };

  const handleUpdateItemGrouping = useCallback((items) => {
    if (_.isArray(items)) {
      items.forEach((item) => {
        const itemIndex = _.findIndex(dataSource, ["item_id", item.id]);
        if (itemIndex >= 0) {
          dataSource[itemIndex].item_group_id = item.item_group_id;
        }
      });
    }
    setGroupItemEnable(false);
  });

  // Function to update items total weight
  function updateItemTotalWeight(data, key) {
    const updatedData = data.map((item) => {
      if (item.key === key) {
        return {
          ...item,
          total_weight:
            item.weight_type === "individual"
              ? item.item_quantity * item.item_weight
              : item.item_weight,
        };
      }
      return item;
    });
    setDataSource(updatedData);
  }

  useEffect(() => {
    getAccountConfigs();
  }, [accountId, currentOrg?.id]);

  useEffect(() => {
    if (currentOrder.customer_order_details) {
      setFieldsValue({
        weight: defaultMeasureValue(details?.weight, "1"),
        cbm_volume:  details?.cbm_volume || '',
      });
      setFormData({
        weight: defaultMeasureValue(details?.weight, 1),
        actual_weight: defaultMeasureValue(details?.actual_weight, 1),
        actual_weight_in_kgs: defaultMeasureValue(details?.actual_weight_in_kgs, 0.453592),
        quantity: defaultMeasureValue(details?.quantity, 1),
        surface_area: defaultMeasureValue(details?.surface_area, 1),
        pallets: defaultMeasureValue(details?.pallets, 1),
        weight_uom: details?.weight_uom || "lbs",
        weight_in_kgs: defaultMeasureValue(details?.weight_in_kgs, 0.453592),
        dimensions_units: details?.dimensions_units || "in",
        mileage: !_.isNil(details?.mileage) ? _.isFinite(Number(details?.mileage)) ? roundToDecimals(details?.mileage, roundOffDecimalsForDistance) : "NA" : "",
        cbm_volume:  details?.cbm_volume || '',
        declared_value: details?.declared_value || '',
      });

      if (currentOrder?.order_items?.length) {
        const updatedDataSource = currentOrder.order_items.map((item) => {
          return {
            ...item,
            key: item.key !== item.id ? item.id : item.key,
            weight_type:
              item.is_indv_weight === 1
                ? "individual"
                : "complete" || "complete",
            dimensions_units: item?.item_height_uom || 'in'
          };
        });
        setDataSource(updatedDataSource);
      }
    }
  }, [currentOrder.order_items, details]);

  // Function to fetch account configs
  const getAccountConfigs = () => {
    const orgId = currentOrg.id;
    if (accountId) {
      fetchAccountDims(orgId, accountId).then((result) => {
        if (result.success) {
          const accountDims = result.configurations || [];
          const dim = accountDims.length > 0 ? accountDims[0] : {};
          setDimObject(dim);
        }else{
          setDimObject({});
        }
      });
    }
  };

  const skipDimValues = _.get(orgRules, 'org_billing_rules.skip_dim_values', 'false');
  const insertionType = currentOrder?.customer_order_details?.insertion_type;
  const callFromUpload = screenFrom || "orders";
  const shouldSkipDimValidation = skipDimValues === 'true' && insertionType === 'PDF' && callFromUpload === "uploadedOrders";

  // Handler to add a new row to the table
  const handleAddNewRow = () => {
    const newRow = {
      key: (dataSource.length + 1).toString(),
      item_name: "",
      pickup_loc_seq : "",
      delivery_loc_seq : "",
      item_model: "",
      serial_number: "",
      item_quantity: 1,
      item_pallets: 0,
      item_weight: requireItems ? "" : 1,
      weight_type: "complete",
      wh_dock: "",
      dim_factor: dimObject?.dim_factor || 194,
      dim_weight: 0,
      item_width: isDimsMandatory ? 0 : 1,
      item_length: isDimsMandatory ? 0 : 1,
      item_height: isDimsMandatory ? 0 : 1,
      item_type: "",
      operation_code: "",
      item_weight_uom: "lbs",
      dimensions_units: "in",
      item_weight_in_kgs: requireItems ? "" : 0.453592,
    };
    const newData = [...dataSource, newRow];
    setDataSource(newData);
    updateOrderTotalWeight(newData);
  };

  // Handler to delete a row from the table
  const handleDeleteRow = (key) => {  
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
    updateOrderTotalWeight(newDataSource);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setItemException([]);
    setIsModalOpen(false);
  };

  const handleInfoClick = (record) => {
    setIsModalOpen(true);
    if (record?.item_data) {
      fetchItemExceptions(record.id).then((result) => {
        if (result.success) {
          setItemException(result.data || []);
        } else {
          setItemException([]);
        }
      });
    }
  };

  const tableColumns = [
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
    },
    {
      title: "Captured By",
      dataIndex: "captured_by",
      key: "captured_by",
    },
    {
      title: "Captured At",
      dataIndex: "captured_at" ,
      key: "captured_at",
      render: (record) => {
        return(
          record ? moment(record).format(timeFormat) : "NA"
        )
      },
    },
    {
      title: "Item Images",
      dataIndex: "item_image",
      key: "item_image",
      render: (images) => (
        <div style={{ display: "flex", gap: "5px" }}>
          {images.map((image, index) => (
            <ImageViewer images={[image]}/>
           
          ))}
        </div>
      ),
    },
    // {
    //   key: "action",
    //   title: "",
    //   width: 50,
    //   align: "center",
    //   fixed: "right",
    //   render: (text, record) => (
    //     <div>
    //         <Icon
    //           type="minus-circle"
    //           onClick={() => handleDeleteRow(record.id)}
    //         />
    //     </div>
    //   ),
    // },
  ];
  // Columns for the table
  const columns = [
    {
      title: "#",
      key: "index",
      width: 40,
      align: "left",
      fixed: "left",
      render: (text, record, index) => (
      <>
        {index + 1}
        &nbsp;&nbsp;
        {record?.customer_order_details?.is_split_order !== true && record?.is_split_item && (
          <Tooltip title="Split Order" placement="top">
            <Icon
              type="apartment"
              style={{
                fontSize: 16,
                color: "#534AB7",
                marginRight: 4,
              }}
            />
          </Tooltip>
        )}
      </>
    )
    },
    {
      title: (
        <span>
          PU Stop<sup style={{ color: "red" }}>&nbsp;*</sup>
        </span>
      ),
      key: "pickup_loc_seq",
      width: 100,
      align: "left",
      render: (text, record, index) => 
        isReadOnly ? (
          text && !isEmpty(text?.pickup_loc_seq) ?  Number(text?.pickup_loc_seq) + 1 : ""
        ) : (
          <Select
          suffixIcon={<ArrowDownIcon />}
          value={record.pickup_loc_seq + "" || ""}
          showSearch
          onChange={(value) =>
            handleTableChange(value, "pickup_loc_seq", record.key)
          }
          className="table-select"
        >
          {locationsData?.filter(
              (location) =>   
                props?.config?.allow_single_stop_multiple_stop == "true" ? location : 
                location.loc_order_sequence !== parseInt(record.delivery_loc_seq) && 
                (isEmpty(record.delivery_loc_seq)||  location.loc_order_sequence < parseInt(record.delivery_loc_seq))
            )
            .map((location) => (
              <Select.Option
                key={location.loc_order_sequence}
                value={location.loc_order_sequence + ""}
              >
                {location.loc_order_sequence + 1}
              </Select.Option>
            ))}
        </Select>
        )
    },
    {
      title: (
        <span>
          DEL Stop<sup style={{ color: "red" }}>&nbsp;*</sup>
        </span>
      ),
      key: "delivery_loc_seq",
      width: 100,
      align: "left",
      render: (text, record, index) => 
        isReadOnly ? (
          text && !isEmpty(text?.delivery_loc_seq) ?  Number(text?.delivery_loc_seq) + 1 : ""
        ) : (
          <Select
          suffixIcon={<ArrowDownIcon />}
            value={record.delivery_loc_seq + "" || ""}
          showSearch
          onChange={(value) =>
            handleTableChange(value, "delivery_loc_seq", record.key)
          }
          className="table-select"
        >
          {locationsData?.filter(
              (location) => 
                props?.config?.allow_single_stop_multiple_stop == "true" ? location : 
                location.loc_order_sequence !== parseInt(record.pickup_loc_seq) &&
                (isEmpty(record.pickup_loc_seq)||  location.loc_order_sequence > parseInt(record.pickup_loc_seq))
            )
            .map((location) => (
              <Select.Option
                key={location.loc_order_sequence}
                value={location.loc_order_sequence + ""}
              >
                {location.loc_order_sequence + 1}
              </Select.Option>
            ))}
          
        </Select>
        )
    },

    {
      title: <span>Item Name</span>,
      dataIndex: "item_name",
      key: "item_name",
      align: "left",
      sorter: (a, b) => a.item_name.localeCompare(b.item_name),
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`item-name-${index}`}
            value={record.item_name}
            onChange={(e) =>
              handleTableChange(e.target.value, "item_name", record.key)
            }
            className="table-input"
          />
        ),
    },
    {
      title: "Model No.",
      dataIndex: "item_model",
      key: "item_model",
      align: "left",
      sorter: (a, b) => a.item_model.localeCompare(b.item_model),
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`item-model-${index}`}
            value={record.item_model}
            onChange={(e) =>
              handleTableChange(e.target.value, "item_model", record.key)
            }
            className="table-input"
          />
        ),
    },
    {
      title: "Serial No.",
      dataIndex: "serial_number",
      key: "serial_number",
      align: "left",
      sorter: (a, b) => a.serial_number.localeCompare(b.serial_number),
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`serial-number-${index}`}
            value={record.serial_number}
            onChange={(e) =>
              handleTableChange(e.target.value, "serial_number", record.key)
            }
            className="table-input"
          />
        ),
    },
    {
      title: "Pcs",
      dataIndex: "item_quantity",
      key: "item_quantity",
      width: 80,
      align: "left",
      sorter: (a, b) => a.item_quantity - b.item_quantity,
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`item-quantity-${index}`}
            type="text"
            value={record.item_quantity}
            onKeyPress={(e) => {
              if (!/^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            // placeholder={record.item_quantity}
            onChange={(e) => {
              const value = Math.max(0, Number(e.target.value));
              handleTableChange(value, "item_quantity", record.key);
            }}
            className="table-input"
          />
        ),
    },
    
    {
      title: requireItems ? <span>Wt.<sup style={{ color: "red" }}>&nbsp;*</sup></span> : "Wt.",
      dataIndex: "item_weight",
      key: "item_weight",
      width: isReadOnly ? 120 : 220, // Adjust width to fit both fields
      align: "left",
      sorter: (a, b) => a.item_weight - b.item_weight,
      render: (text, record, index) =>
        isReadOnly ? (
          <>
            {formatWeight(record.item_weight, true, record.item_weight, "lbs")} <br />
            <span style={{ color: "#d0d0d0", marginTop: "5px" }}>
              {formatWeight(record.item_weight_in_kgs, false, "", "kgs")}
            </span>
          </>
        ) : (
          <div
            className="table-cell wt-cell"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <Input
              data-testid={`item-weight-${index}`}
              type="text"
              value={isEmpty(record?.item_weight) ? "" : record.item_weight}
              placeholder="Enter weight"
              onChange={(e) => {
                let value = e.target.value;
                value = value.replace(/[^0-9.]/g, "");
                // handle multiple dots
                const parts = value.split(".");
                if (parts.length > 2) {
                  value = `${parts[0]}.${parts[1]}`;
                }
                handleTableChange(value, "item_weight", record.key);
              }}
              onBlur={(e) => {
                let value = e.target.value;
                // Add a leading 0 if the input starts with a '.'
                const isStartWithDot = value.startsWith(".");
                const isEndingWithDot = value.endsWith(".");
                if (isStartWithDot) {
                  value = `0${value}`;
                }
                // Remove trailing '.' if present
                if (isEndingWithDot) {
                  value = value.slice(0, -1);
                }
                const numValue = value ? parseFloat(value) : 0;
                if (isStartWithDot || isEndingWithDot) {
                handleTableChange(numValue, "item_weight", record.key);
                }
              }}
              suffix="lbs"
              className="input_weight"
            />
            <Input
              data-testid={`item-weight-kgs-${index}`}
              type="text"
              value={record.item_weight_in_kgs}
              placeholder="Enter weight"
              onChange={(e) => {
                let value = e.target.value;
                value = value.replace(/[^0-9.]/g, "");
                // handle multiple dots
                const parts = value.split(".");
                if (parts.length > 2) {
                  value = `${parts[0]}.${parts[1]}`;
                }
                handleTableChange(value, "item_weight_in_kgs", record.key);
              }}
              onBlur={(e) => {
                let value = e.target.value;
                // Add a leading 0 if the input starts with a '.'
                const isStartWithDot = value.startsWith(".");
                const isEndingWithDot = value.endsWith(".");
                if (isStartWithDot) {
                  value = `0${value}`;
                }
                // Remove trailing '.' if present
                if (isEndingWithDot) {
                  value = value.slice(0, -1);
                }
                const numValue = value ? parseFloat(value) : 0;
                if (isStartWithDot || isEndingWithDot) {
                handleTableChange(numValue, "item_weight_in_kgs", record.key);
                }
              }}
              className="input_weight"
              suffix="kgs"
            />


          </div>
        ),
    },

    {
      title: "Wt. Type",
      dataIndex: "weight_type",
      key: "weight_type",
      width: 80,
      align: "left",
      sorter: (a, b) => a.weight_type.localeCompare(b.weight_type),
      render: (text, record, index) =>
        isReadOnly ? (
          record.is_indv_weight === 1 ? (
            "Individual"
          ) : (
            "Complete"
          )
        ) : (
          <div className="weightTypeToggleButton" data-testid={`weight-type-${index}`}>
            <div
              onClick={() =>
                handleTableChange("individual", "weight_type", record.key)
              }
              className={`orderListIconContainer ${
                (record.weight_type ||
                  (record.is_indv_weight === 1 ? "individual" : "complete")) ===
                "individual"
                  ? "buttonActive"
                  : "buttonDefaultColor"
              }`}
            >
              Indv
              {record.weight_type === "individual" && (
                <img className="polygon" src={polygonActive} alt="^" />
              )}
            </div>

            <div
              onClick={() =>
                handleTableChange("complete", "weight_type", record.key)
              }
              className={`driverMapIconContainer ${
                (record.weight_type ||
                  (record.is_indv_weight === 1 ? "individual" : "complete")) ===
                "complete"
                  ? "buttonActive"
                  : "buttonDefaultColor"
              }`}
            >
              Comp
              {record.weight_type === "complete" && (
                <img className="polygon" src={polygonActive} alt="^" />
              )}
            </div>
          </div>
        ),
    },
    {
      title: currentOrg?.code === "SFO" ? "Chargeable Wt." : "Total Wt.",
      dataIndex: "total_weight",
      key: "total_weight",
      width: 150,
      align: "left",
      sorter: (a, b) => a.total_weight - b.total_weight,
      render: (text, record) => {
        return (
          <div style={{ textAlign: "left", marginLeft: "5px" }}>
            <span style={{ color: "inherit" }}>
              {record?.total_weight || 1} lbs
            </span>
            <br />

            <span style={{ color: "#d0d0d0", marginTop: "5px" }}>
              {convertToKilograms(record?.total_weight || 1, true)} 
            </span>
            {/* 
            <br />
            */}
          </div>
        );
      },
    },
    {
      title: "WH Dock",
      dataIndex: "wh_dock",
      key: "wh_dock",
      width: 100,
      align: "left",
      sorter: (a, b) => a.wh_dock.localeCompare(b.wh_dock),
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`wh-dock-${index}`}
            value={record.wh_dock}
            onChange={(e) =>
              handleTableChange(e.target.value, "wh_dock", record.key)
            }
            className="table-input"
          />
        ),
    },
    {
      title: (
        <span>
          L x W x H {isDimsMandatory && <sup style={{ color: "red" }}>*</sup>}
        </span>
      ),
      dataIndex: "dimensions",
      key: "dimensions",
      width: 200,
      align: "left",
      sorter: (a, b) =>
        formatDimension_v2(
          a.item_length,
          a.item_length_uom,
          a.item_width,
          a.item_width_uom,
          a.item_height,
          a.item_height_uom
        ).localeCompare(
          formatDimension_v2(
            b.item_length,
            b.item_length_uom,
            b.item_width,
            b.item_width_uom,
            b.item_height,
            b.item_height_uom
          )
        ),
      render: (text, record, index) =>
        isReadOnly ? (
          <div className="table-cell">
            {formatDimension_v2(
              record.item_length,
              record.item_length_uom,
              record.item_width,
              record.item_width_uom,
              record.item_height,
              record.item_height_uom
            )}
          </div>
        ) : (
          <div className="table-cell">
            <Input
              data-testid={`item-length-${index}`}
              value={record.item_length}
              onChange={(e) => {
                const inputValue = e.target.value;
                const numericValue = inputValue === "" ? 0 : Number(inputValue);
                 if (!isNaN(numericValue)) {
                const value = Math.max(0, numericValue); // Ensure non-negative values
                  handleTableChange(value, "item_length", record.key);
                }
              }}
              className="dimension-input"
                placeholder={isDimsMandatory ? "0" : "1"}
            />
            <Input
              data-testid={`item-width-${index}`}
              value={record.item_width}
              onChange={(e) => {
                const inputValue = e.target.value;
                const numericValue = inputValue === "" ? 0 : Number(inputValue)
                if (!isNaN(numericValue)) {
               const value = Math.max(0, numericValue); // Ensure non-negative values
                handleTableChange(value, "item_width", record.key);
                }
              }}
              className="dimension-input"
                placeholder={isDimsMandatory ? "0" : "1"}
            />
            <Input
              data-testid={`item-height-${index}`}
              value={record.item_height}
              onChange={(e) => {
                const inputValue = e.target.value;
                const numericValue = inputValue === "" ? 0 : Number(inputValue)
                if (!isNaN(numericValue)) {
               const value = Math.max(0, numericValue); // Ensure non-negative values
                handleTableChange(value, "item_height", record.key);
                }
              }}
              className="dimension-input"
                placeholder={isDimsMandatory ? "0" : "1"}
            />
          </div>
        ),
    },
    {
      title: "Units",
      dataIndex: "dimensions_units",
      key: "dimensions_units",
      width: 80,
      align: "left",
      sorter: (a, b) => a.dimensions_units.localeCompare(b.dimensions_units),
      render: (text, record, index) =>
        isReadOnly ? (
          record.item_length_uom ||
          record.item_width_uom ||
          record.item_height_uom
        ) : (
          <Select
            data-testid={`dimensions-units-${index}`}
            suffixIcon={<ArrowDownIcon />}
            value={record.dimensions_units || record.item_length_uom}
            onChange={(value) =>
              handleTableChange(value, "dimensions_units", record.key)
            }
            className="table-select"
          >
            <Option value="in">in</Option>
            <Option value="cm">cm</Option>
            <Option value="ft">ft</Option>
          </Select>
        ),
    },
    {
      title: "Skids/Pallets",
      dataIndex: "item_pallets",
      key: "item_pallets",
      width: 80,
      align: "left",
      sorter: (a, b) => a.item_pallets - b.item_pallets,
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Input
            data-testid={`item-pallets-${index}`}
            type="text"
            value={record.item_pallets}
            onKeyPress={(e) => {
              if (!/^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            // placeholder={record.item_pallets}
            onChange={(e) => {
              const value = Math.max(0, Number(e.target.value));
              handleTableChange(value, "item_pallets", record.key);
            }}
            className="table-input"
          />
        ),
    },
    {
      title: (
        <span>
          DIM Fact.{!shouldSkipDimValidation && <sup style={{ color: "red" }}>&nbsp;*</sup>}
        </span>
      ),
      dataIndex: "dim_factor",
      key: "dim_factor",
      width: 120,
      align: "left",
      sorter: (a, b) => a.dim_factor - b.dim_factor,
      render: (text, record, index) =>
        isReadOnly ? (
          text
        ) : (
          <Form.Item colon={false}>
            {getFieldDecorator(`dim_factor_${record.key}`, {
              rules: shouldSkipDimValidation ? [] : [{ required: true, message: "Select Dim Factor" }],
              initialValue: record.dim_factor,
            })(
              <Select
                data-testid={`dim-factor-${index}`}
                suffixIcon={<ArrowDownIcon />}
                onChange={(value) =>
                  handleTableChange(value, "dim_factor", record.key)
                }
                className="table-select"
              >
                {dimObject?.configured_dim_factors?.map((key) => (
                  <Select.Option value={key} key={key}>
                    {key}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        ),
    },
    {
      title: "DIM Wt.",
      dataIndex: "dim_weight",
      key: "dim_weight",
      width: 80,
      align: "left",
      sorter: (a, b) => a.dim_weight - b.dim_weight,
      render: (text, record) => {
        // const dimWeight = calculateDimValue(record);
        return <div className="table-cell">{record.dim_weight}</div>;
      },
    },
    ...(props.checkForRemark === "true"
      ? [
          {
            key: "items_remark",
            title: <div>{props.itemRemarkLabel}</div>,
            dataIndex: "item_remarks",
          },
        ]
      : []),
    {
      title: "",
      key: "item_status",
      width: 30,
      align: "center",
      fixed: "right",
      render: (text, record, index) => (
        <>
          <div className="textRed action-icons-item-measures-table" data-testid={`action-buttons-${index}`}>
            {record.item_picture_data && (
              <InfoIcon
                width="24"
                height="24"
                className="info-icon"
                onClick={() => handleInfoClick(record)}
                styling={{ margin: "8px" }}
              />
            )}

            {
              isReadOnly ? null : (
                <DeleteMinusIcon
                width="24"
                height="24"
                color="#576EC1"
                onClick={() => handleDeleteRow(record.key)}
              />
              )
            }
              
          </div>
        </>
      ),      
    },
  ];
  

  const finalColumns = isReadOnly
    ? typeOfOrder !== 'MS' ? columns.filter((col) => !["action","pickup_loc_seq","delivery_loc_seq"].includes(col.key)) : columns.filter((col) => !["action"].includes(col.key))
    : typeOfOrder !== 'MS' ? columns.filter((col) => !["pickup_loc_seq","delivery_loc_seq"].includes(col.key)) : [...columns];
  
  const dimFilteredColumns = dimObject && !isEmpty(dimObject.dim_factor) ? [...finalColumns] : finalColumns.filter((col) =>!["dim_factor", "dim_weight"].includes(col.key));
  

  const renderButton = () => {
    if (actionType === "view") {
      // Display the "Group items" button first
      const isLinehaul = typeOfOrder === 'LH' && currentOrder.label_code === 'LH';
      return (
        <>
        {!isLinehaul && (
           <ButtonComponent
           data-testid="group-items-button"
           type="secondary"
           className="outline small-btn"
           onClick={handleGroupItemClick}
           text="Group items"
           disabled={isShipper || isEditting || dataSource?.length <= 1}
         />
        
        )}
         
         &nbsp;
          {/* Display either "Edit Items" or "Save Items" based on `isEditting` */}
          {!isEditting ? (
            <ButtonComponent
              data-testid="edit-item-button"
              type="secondary"
              className="outline small-btn"
              onClick={handleEditItemClick}
              text="Edit"
              disabled={isShipper || groupitemEnable}
            />
          ) : (
            <ButtonComponent
              data-testid="save-item-button"
              type="secondary"
              className="outline small-btn"
              onClick={handleSaveItemClick}
              text={typeOfOrder === 'LH' ? 'Save' : 'Save Items'}
            />
          )}
        </>
      );
    } else if (["create", "update"].includes(actionType) && typeOfOrder !== 'LH') {
      if (!showTable) {
        return (
          <ButtonComponent
            data-testid="add-items-button"
            type="secondary"
            className="outline small-btn"
            onClick={handleAddItemClick}
            text="Add Items"
            disabled={isShipper}
          />
        );
      }
    }
    return null; // Return null if no button should be displayed
  };

  const showInputsEnable = isEditting || ["create", "update"].includes(actionType);
  const isLinehaul = typeOfOrder === 'LH' && currentOrder.label_code === 'LH';
  return (
    <>
      <SectionCard
        title="Items & Measure"
        extraActionNode={showActions && renderButton()}
      >
        <>
          {showInputsEnable && (
            <>
            <Row gutter={16}>
              <Col span={3} xs={24} sm={12} md={8} lg={6} xl={4} className="table-col">
              <Row>
                 <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('total weight')}
                   onMouseLeave={() => setHoveredField(null)}>
                <Form.Item
                  style={{ fontSize: "14px" }}
                  colon={false}
                  className="custom-form-item required-star-right"
                >
                  <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                          <span className={`heading-3-large${requireItems ? "" : " require-star-right"}`} >{currentOrg?.code == "SFO" ? "Chargeable Weight" : "Total Weight"}</span>
                       {hoveredField === 'total weight' && (
                         <InfoTooltip
                           label="Total Weight"
                           //icon={<RefNumTooltipIcon />}
                           message={[
                             "The Total Weight field displays the combined weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order, reflecting their combined weights.Total weight is a critical factor during planning and routing, as it influences whether an order can be assigned to a route without exceeding the vehicle's maximum weight capacity."
                           ]}
                         />
                       )}
                     </div>
                  {getFieldDecorator("weight", {
                    initialValue: formData.weight,
                    rules: requireItems
                      ? []
                      : [
                          { required: true, message: "Total Weight is required" },
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                    "Total Weight must be a non-negative number"
                                  ),
                          },
                        ],
                  })(
                    <ReusableInput
                      data-testid="total-weight-input" 
                      suffix="lbs"
                      placeholder="Enter Weight"
                      disabled={requireItems}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = Number(inputValue);
                        const value = isNaN(numericValue)
                          ? 0
                          : Math.max(0, numericValue);
                        handleInputChange("weight", value);
                      }}
                    />
                  )}
                </Form.Item>
                </Col>
                
                </Row>
              </Col>

              <Col span={3} className="table-col">
              <Row>
                 <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('weight in Kgs')}
                   onMouseLeave={() => setHoveredField(null)}>
                   <Form.Item
                     style={{ fontSize: "14px" }}
                     colon={false}
                     className="custom-form-item"
                   >
                     <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                       <span className="heading-3-large " >{currentOrg?.code == "SFO" ? "Chargeable Wt in Kgs" : "Weight in Kgs"}</span>
                       {hoveredField === 'weight in Kgs' && (
                         <InfoTooltip
                           label="weight in Kgs"
                           //icon={<RefNumTooltipIcon />}
                           message={[
                             "The Total Weight field displays the combined weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order, reflecting their combined weights.Total weight is a critical factor during planning and routing, as it influences whether an order can be assigned to a route without exceeding the vehicle's maximum weight capacity."
                           ]}
                         />
                       )}
                     </div>
                  {getFieldDecorator("weight_in_kgs", {
                    initialValue: toTwoDecimals(formData.weight_in_kgs),
                    rules: requireItems
                      ? []
                      : [
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                    "Weight in Kgs must be a non-negative number"
                                  ),
                          },
                        ],
                  })(
                    <ReusableInput
                      data-testid="weight-in-kgs-input" 
                      suffix="kgs"
                      placeholder="Enter Weight in Kgs"
                      disabled={requireItems}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = Number(inputValue);
                        const value = isNaN(numericValue)
                          ? 0
                          : Math.max(0, numericValue);
                        handleInputChange("weight_in_kgs", value);
                      }}
                    />
                  )}
                </Form.Item>
                </Col>
                </Row>
              </Col>

              <Col span={3} className="table-col">
                <Row>
                  <Col style={{ lineHeight: "30px", }}
                  // onMouseEnter={() => setHoveredField('weight in Kgs')}
                  // onMouseLeave={() => setHoveredField(null)}
                  >
                    <Form.Item
                      style={{ fontSize: "14px" }}
                      colon={false}
                      className="custom-form-item"
                    >
                      <div
                        className="RefNumbersStyle"
                        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      >
                        <span className="heading-3-large " >{currentOrg?.code == "SFO" ? "Cargo Weight" : "Actual Weight"}</span>
                        {/* {hoveredField === 'weight in Kgs' && (
                          <InfoTooltip
                            label="Actual Weight"
                          //  message={[
                          //    "The Actual Weight field displays the actual weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order."
                          //  ]}
                          />
                        )} */}
                      </div>
                      {getFieldDecorator("actual_weight", {
                        initialValue: toTwoDecimals(formData.actual_weight),
                        rules: [
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                  "Actual Weight must be a non-negative number"
                                ),
                          },
                        ],
                      })(
                        <ReusableInput
                          data-testid="actual-weight-input" 
                          suffix="lbs"
                          placeholder="Enter Weight in Lbs"
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const numericValue = Number(inputValue);
                            const value = isNaN(numericValue)
                              ? 0
                              : Math.max(0, numericValue);
                            handleInputChange("actual_weight", value);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col span={3} className="table-col">
                <Row>
                  <Col style={{ lineHeight: "30px", }}
                  // onMouseEnter={() => setHoveredField('weight in Kgs')}
                  // onMouseLeave={() => setHoveredField(null)}
                  >
                    <Form.Item
                      style={{ fontSize: "14px" }}
                      colon={false}
                      className="custom-form-item"
                    >
                      <div
                        className="RefNumbersStyle"
                        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      >
                        <span className="heading-3-large " >{currentOrg?.code === "SFO" ? "Cargo Weight in Kgs" : "Actual Weight in Kgs"}</span>
                        {/* {hoveredField === 'actual_weight' && (
                          <InfoTooltip
                            label="Actual Weight in Kgs"
                          //  message={[
                          //   "The Actual Weight field displays the actual weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order."
                          //  ]}
                          />
                        )} */}
                      </div>
                      {getFieldDecorator("actual_weight_in_kgs", {
                        initialValue: toTwoDecimals(formData.actual_weight_in_kgs),
                        rules: [
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                  "Actual Weight in Kgs must be a non-negative number"
                                ),
                          },
                        ],
                      })(
                        <ReusableInput
                          data-testid="actual-weight-kgs-input"
                          suffix="kgs"
                          placeholder="Enter Weight in Kgs"
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const numericValue = Number(inputValue);
                            const value = isNaN(numericValue)
                              ? 0
                              : Math.max(0, numericValue);
                            handleInputChange("actual_weight_in_kgs", value);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              {!isEmpty(orgSettings.cbm_volume) && 
                <Col span={3} className="table-col">
                  <Row>
                    <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('cbm_volume')}
                        onMouseLeave={() => setHoveredField(null)}>
                      <Form.Item
                        style={{ fontSize: "14px" }}
                        colon={false}
                        className="custom-form-item"
                      >
                        <div
                          className="RefNumbersStyle"
                          style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                        >
                          <span className="heading-3-large">Cubic Meters</span>
                          {hoveredField === 'cbm_volume' && (
                            <InfoTooltip
                              label="Cubic Meters"
                              //icon={<RefNumTooltipIcon />}
                              message={[
                                "The Cubic meter represents the total volumne for the delivery or route. This value is essential for planning the most efficient route and ensuring that vehicles are scheduled appropriately based on distance."
                              ]}
                            />
                          )}
                        </div>
                        {getFieldDecorator("cbm_volume", {
                        initialValue: formData.cbm_volume,
                        rules: [
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                    "Weight in Kgs must be a non-negative number"
                                  ),
                          },
                        ],
                      })(
                        <ReusableInput
                          data-testid="cubic-meters-input"
                          suffix={<Fragment>m<sup>3</sup></Fragment>}
                          type="number"
                          value={formData.cbm_volume || ''}
                          step ="1"
                          precision={0}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const numericValue = Number(inputValue);
                            const value = isNaN(numericValue) || inputValue === ''
                              ? ''
                              : Math.max(0, numericValue);
                            handleInputChange("cbm_volume", value);
                          }}
                        />)}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              }
              <Col span={5} className="table-col">
              <Row>
              <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('Quantity')}
                   onMouseLeave={() => setHoveredField(null)}>
                   <Form.Item
                     style={{ fontSize: "14px" }}
                     colon={false}
                     className="custom-form-item"
                   >
                     <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                       <span className="heading-3-large">Quantity/Number of Items</span>
                       {hoveredField === 'Quantity' && (
                         <InfoTooltip
                           label="Quantity/Number of Items"
                           //icon={<RefNumTooltipIcon />}
                           message={[
                             "The Quantity field indicates the total number of items included in the order. This value can be manually entered but is overridden when items are added, reflecting their combined count.While quantity does not affect preplanning, it provides an expectation for dispatch and drivers regarding the volume of items being picked up or delivered."
                           ]}
                         />
                       )}
                     </div>

              {/* <Col span={4} className="table-col">
                <Form.Item
                  style={{ fontSize: "14px" }}
                  label=" "
                  colon={false}
                  className="custom-form-item"
                >
                  {getFieldDecorator("weight_in_kgs", {
                    initialValue: formData.weight_in_kgs.toFixed(2),
                    rules: [
                      {
                        validator: (_, value) =>
                          value >= 0
                            ? Promise.resolve()
                            : Promise.reject(
                                "Weight in Kgs must be a non-negative number"
                              ),
                      },
                    ],
                  })(
                    <ReusableInput
                      suffix="kgs"
                      placeholder="Enter Weight in Kgs"
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = Number(inputValue);
                        const value = isNaN(numericValue)
                          ? 0
                          : Math.max(0, numericValue);
                        handleInputChange("weight_in_kgs", value);
                      }}
                    />
                  )}
                </Form.Item>
              </Col> */}
                  <ReusableInput
                    data-testid="quantity-input" 
                    // type="number"
                    value={formData.quantity}
                    placeholder="1"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const numericValue = Number(inputValue);
                      const value = isNaN(numericValue)
                        ? 0
                        : Math.max(0, numericValue);
                      handleInputChange("quantity", value);
                    }}
                  />
                </Form.Item>
                </Col>
                </Row>
              </Col>
              <Col span={3} className="table-col">
              <Row>
                 <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('surface_area')}
                   onMouseLeave={() => setHoveredField(null)}>
                   <Form.Item
                     style={{ fontSize: "14px" }}
                     colon={false}
                     className="custom-form-item"
                   >
                     <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                       <span className="heading-3-large">Surface Area</span>
                       {hoveredField === 'surface_area' && (
                         <InfoTooltip
                           label="Surface Area"
                           //icon={<RefNumTooltipIcon />}
                           message={[
                             "The Surface Area field represents the total square inches required for the items in an order within a truckload. This value is a key consideration during preplanning and dispatching, as it helps determine whether an order can fit on a vehicle based on available space."
                           ]}
                         />
                       )}
                     </div>

                  <ReusableInput
                    data-testid="surface-area-input"
                    // type="number"
                    suffix="in²"
                    value={formData.surface_area}
                    placeholder="Enter Surface Area"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const numericValue = Number(inputValue);
                      const value = isNaN(numericValue)
                        ? 0
                        : Math.max(0, numericValue);
                      handleInputChange("surface_area", value);
                    }}
                  />
                </Form.Item>
                </Col>
                </Row>
              </Col>
              <Col span={2} className="table-col">
              <Row>
                 <Col style={{ lineHeight: "30px", paddingTop: "10px" }} onMouseEnter={() => setHoveredField('pallets')}
                   onMouseLeave={() => setHoveredField(null)}>
                   <Form.Item
                     style={{ fontSize: "14px" }}
                     colon={false}
                     className="custom-form-item"
                   >
                     <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                       <span className="heading-3-large">Skids/Pallets</span>
                       {hoveredField === 'pallets' && (
                         <InfoTooltip
                           label="Skids/Pallets"
                           //icon={<RefNumTooltipIcon />}
                           message={[

                             "The Skids/Pallets field shows the total number of pallets or skids included in the order. This value is critical during preplanning and dispatching, as it ensures that orders are assigned to routes with vehicles capable of accommodating the required pallet space."
                           ]}
                         />
                       )}
                     </div>
                  <ReusableInput
                    data-testid="skills-pallets-input"
                    // type="number"
                    value={formData.pallets}
                    placeholder="1"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const numericValue = Number(inputValue);
                      const value = isNaN(numericValue)
                        ? 0
                        : Math.max(0, numericValue);
                      handleInputChange("pallets", value);
                    }}
                  />
                </Form.Item>
                </Col>
                </Row>
              </Col>
                   {["R","D","M","LH","MS","TR","TD"].includes(typeOfOrder) &&  <Col span={4} className="table-col" style={{ lineHeight: "30px", padding: "10px" }}>
             <Row>
                <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('mileage')}
                    onMouseLeave={() => setHoveredField(null)}>
                  <Form.Item
                    style={{ fontSize: "14px" }}
                    colon={false}
                    className="custom-form-item"
                  >
                     <div
                       className="RefNumbersStyle"
                       style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                     >
                       <span className="heading-3-large">Miles</span>
                       {hoveredField === 'mileage' && (
                         <InfoTooltip
                           label="Miles"
                           //icon={<RefNumTooltipIcon />}
                           message={[
                             "The Miles represents the total distance for the delivery or route. This value is essential for planning the most efficient route and ensuring that vehicles are scheduled appropriately based on distance."
                           ]}
                         />
                       )}
                     </div>
                    <ReusableInput
                      data-testid="miles-input" 
                      type="number"
                      value={formData.mileage ?? ""}
                      step ="1"
                      precision={0}
                      min={0}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = Number(inputValue);
                        const value = isNaN(numericValue) || inputValue === ''
                          ? 0
                          : Math.max(0, numericValue);
                        handleInputChange("mileage", value);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              </Col>}
             {/* Declaration */}
                  <Col span={4} style={{ lineHeight: "30px", padding: "10px" }}
                  // onMouseEnter={() => setHoveredField('weight in Kgs')}
                  // onMouseLeave={() => setHoveredField(null)}
                  >
                    <Form.Item
                      style={{ fontSize: "14px" }}
                      colon={false}
                      className="custom-form-item"
                    >
                      <div
                        className="RefNumbersStyle"
                        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      >
                        <span className="heading-3-large " >Declared Value</span>
                      </div>
                      {getFieldDecorator("declared_value", {
                        initialValue: formData?.declared_value ?? "0.00",
                        rules: [
                          {
                            validator: (_, value) =>
                              value >= 0
                                ? Promise.resolve()
                                : Promise.reject(
                                  "Actual Weight must be a non-negative number"
                                ),
                          },
                        ],
                      })(
                        <ReusableInput
                          suffix="$"
                          placeholder="Enter Value in $"
                          value={formData?.declared_value ?? "0"}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const numericValue = Number(inputValue);
                            const value = isNaN(numericValue)
                              ? 0
                              : Math.max(0, numericValue);
                            handleInputChange("declared_value", value);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
            </Row>
            </>
          )}
          {!isEditting && actionType === "view" && (
            <Row gutter={16}>
              <Col span={3} className="table-col">
                <div className="lable_items">{currentOrg?.code === "SFO" ? "Chargeable Weight" : "Total Weight"}</div>
                <div>
                  {" "}
                  <span className="item_values">
                    {formData.weight}
                  </span>&nbsp; <span className="item_units">lbs</span>
                </div>
              </Col>

              <Col span={3} className="table-col">
                <div className="lable_items">{currentOrg?.code === "SFO" ? "Chargeable Weight in Kgs" : "Total Weight in Kgs"}</div>
                <div>
                  {" "}
                  <span className="item_values">
                    {convertToKilograms(formData.weight,false,2)}
                  </span>
                  &nbsp; <span className="item_units">kgs</span>
                </div>
              </Col>

              <Col span={3} className="table-col">
                <div className="lable_items">{currentOrg?.code === "SFO" ? "Cargo Weight" : "Actual Weight"}</div>
                <div>
                  {" "}
                  <span className="item_values">
                    {formData.actual_weight}
                  </span>
                  &nbsp; <span className="item_units">lbs</span>
                </div>
              </Col>

              <Col span={3} className="table-col">
                <div className="lable_items">{currentOrg?.code === "SFO" ? "Cargo Weight in Kgs" : "Actual Weight in Kgs"}</div>
                <div>
                  {" "}
                  <span className="item_values">
                    {formData.actual_weight_in_kgs ? _.round(formData.actual_weight_in_kgs, 2) : convertToKilograms(formData.actual_weight, false, 2)}
                  </span>
                  &nbsp; <span className="item_units">kgs</span>
                </div>
              </Col>

              {!isEmpty(orgSettings.cbm_volume) && <Col span={3} className="table-col">
                <div className="lable_items"> Cubic Meters </div>
                <div>
                  {" "}
                  <span className="item_values">{formData.cbm_volume || emptyText}</span>
                </div>
              </Col>}
              <Col span={3} className="table-col">
                <div className="lable_items"> Quantity/No. of Items </div>
                <div>
                  {" "}
                  <span className="item_values">{formData.quantity}</span>
                </div>
              </Col>
              <Col span={2} className="table-col">
                <div className="lable_items">Surface Area</div>
                <div>
                  {" "}
                  <span className="item_values">{formData.surface_area}</span>
                  &nbsp; <span className="item_units">in²</span>
                </div>
              </Col>
              <Col span={2} className="table-col">
                <div className="lable_items"> Skids / Pallets </div>
                <div>
                  {" "}
                  <span className="item_values">{formData.pallets}</span>
                </div>
              </Col>
              {["M","LH","D","R","MS","TR","TD"].includes(typeOfOrder) && <Col span={2} className="table-col">
                <div className="lable_items"> Miles </div>
                <div>
                  {" "}
                  <span className="item_values">{formData.mileage !== "NA" ? _.round(formData.mileage, roundOffDecimalsForDistance) : formData.mileage}</span>
                </div>
              </Col>}
             <Col span={2} className="table-col">
                <div className="lable_items"> Declared Value </div>
                <div>
                  {" "}
                  <span className="item_values">{formData.declared_value || "N/A"}</span>
                </div>
              </Col>
             
            </Row>
          )}

          {!isLinehaul && showTable && (
            <>
              {groupitemEnable ? (
                // <></>

                <ItemGrouping
                  items={dataSource || []}
                  onCancel={() => {
                    setGroupItemEnable(false);
                  }}
                  updateItems={(updatedItems) => {
                    handleUpdateItemGrouping(updatedItems);
                  }}
                  customer_order_id={details.id}
                />
              ) : (
                <div className="items-measure-table-scroll" data-testid="items-list">
                <TableComponent
                  columns={dimFilteredColumns}
                  dataSource={dataSource}
                  pagination={false}
                  className="items-measure-table"
                  style={{ marginTop: "16px" }}
                  scroll={{ x: "max-content" }}
                  rowKey='key'
                  />
                  {/* <ItemsMeasureGridList
                  tableName={ScreenKeys.ITEMSlISTING_SCREEN}
                  rawDataSource={dataSource}
                  isReadOnly={isReadOnly}
                  handleTableChange={handleTableChange}
                  locationsData={locationsData}
                  formatWeight={formatWeight}
                  convertToKilograms={convertToKilograms}
                  formatDimension_v2={formatDimension_v2}
                  handleInfoClick={handleInfoClick}
                  handleDeleteRow={handleDeleteRow}
                  checkForRemark={props.checkForRemark}
                  itemRemarkLabel={props.itemRemarkLabel}
                  showPagination={false}
                  onGridReady={onGridReady}
                  columns={dimFilteredColumns}
                  typeOfOrder={typeOfOrder}
                  dimObject={dimObject}
                  /> */}
                  {/* <TestGrid/> */}
                  </div>
              )}

              {["view","update"].includes(actionType) ? (
                isEditting ? (
                  <ButtonComponent
                    data-testid="add-item-button"
                    type="secondary"
                    onClick={handleAddNewRow}
                    text="Add Item"
                    className="outline small-btn"
                    style={{ marginTop: "16px" }}
                    disabled={isShipper || groupitemEnable}
                  />
                ) : null
              ) : (
                <ButtonComponent
                  data-testid="add-item-button"
                  type="secondary"
                  onClick={handleAddNewRow}
                  text="Add Item"
                  className="outline small-btn"
                  style={{ marginTop: "8px" }}
                  disabled={isShipper || groupitemEnable}
                />
              )}
            </>
          )}
        </>
      </SectionCard>
      {/* {isModalOpen && handleInfoClick()} */}
      <ApprovalRequiredModal 
        visible={approvalModal} 
        onCancel={() => handleCloseApprovalModal(false)} 
        onRequestApproval={handleSaveItemClick} 
        restrictionMessage={restrictionMessage} 
        reqLoading={false}
      />
      {isModalOpen && (
        <ModalComponent
          visible={isModalOpen}
          onCancel={closeModal}
          title={
            <div className="modal-header">
              <span>Item Exception</span>
              <div className="custom-close-icon-wrapper">
                <Tooltip title="Close">
                  {/* <CloseIcon/> */}
                  <img src={CloseIcon} alt="" onClick={closeModal} />
                  {/* <CircledCloseIcon
                  color="#576EC1"
                  width="55px"
                  height="55px"
                  onClick={closeModal}
                  style={{ cursor: "pointer" }}
                /> */}
                </Tooltip>
              </div>
            </div>
          }
          content={
            <div className="table-container-shipper ">
              <Table_v2
                columns={tableColumns.filter((col) => col.key !== "action")}
                dataSource={itemException}
                // pagination
                // rowSelection={rowSelection}
                rowKey="id"
                scroll={{
                  y: "400px",
                }}
              />
            </div>
          }
          closable={false}
          // okText="Add Accessorial"
          width={720}
          height={600}
          centered
          // okButtonProps={{ className: "medium-btn raised" }}
          // cancelButtonProps={{ className: "medium-btn flat" }}
          footer={
            null
            // <Button_v2
            //   key="cancel"
            //   text="Cancel"
            //   className="flat medium-btn"
            //   onClick={closeModal}
            // />,
            // <Button_v2
            //   key="confirm"
            //   text="Save"
            //   type="primary"
            //   className="raised medium-btn"
            //   onClick={handleSave}
            // />,
          }
        />
      )}
    </>
  );
};

export default ItemsMeasure;